import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';

import { ModalWebFormComponent } from './modal-webform.component';
import { WebFormComponent } from './webform.component';
import { TranslationIdMap } from './webform.i18n';
import { WebFormRoutes } from './webform.route';

@NgModule({
    imports: [
        CommonModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(WebFormRoutes),
        CmpsIconModule,
    ],
    declarations: [WebFormComponent, ModalWebFormComponent],
})
export class CmpsWebFormModule {}
